export const actionTypes = {
  HANDLER_SEARCH_OVERLAY: 'APP.SEARCH_OVERLAY.HANDLER',
};

export function handlerSearch() {
  return {
    type: actionTypes.HANDLER_SEARCH_OVERLAY,
  };
}
